export const ACCESS_LEVEL_PERMISSION = {
  allCalendars: 'allCalendars',
  clientDetails: 'clientDetails',
  checkout: 'checkout',
  waitlist: 'waitlist',
  airSummary: 'airSummary',
} as const
